import { Reveal } from "@/lib/motion";

const TOOLS = [
  "Slack",
  "Microsoft Teams",
  "Jira",
  "HubSpot",
  "Zendesk",
  "Email",
  "Webhooks",
];

export default function Integrations() {
  const row = [...TOOLS, ...TOOLS];
  return (
    <section
      id="integrations"
      className="relative overflow-hidden border-y border-hairline bg-bg-surface/45 py-16 backdrop-blur-sm"
    >
      <div className="container-max band-pad">
        <Reveal>
          <p className="text-center font-mono text-xs uppercase tracking-[0.22em] text-ink-muted">
            Works inside the tools your team already lives in
          </p>
        </Reveal>
      </div>

      {/* slow editorial marquee */}
      <div className="relative mt-10">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-bg-surface to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-bg-surface to-transparent" />
        <div
          data-testid="integrations-marquee"
          className="flex w-max animate-marquee items-center gap-14 whitespace-nowrap"
        >
          {row.map((t, i) => (
            <div key={i} className="flex items-center gap-14">
              <span className="font-display text-2xl font-medium tracking-tight text-ink/70 transition-colors hover:text-ink sm:text-3xl">
                {t}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-signal/50" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
